<template>
    <div class="tasks-list-wrapper step_4">
        <h1>{{$t('tests.wizard.payment_step.headline')}}</h1>
        <b-row>
            <b-col cols="12" md="8" order="2" order-md="1" :class="{blurred: !paymentMethods || price === 0}">
                <b-row v-if="(!paymentMethods || paymentMethods.length > 1) && !showForm">
                    <b-col cols="12">
                        <h3>{{$t('tests.wizard.payment_step.select_payment_method')}}</h3>
                    </b-col>
                </b-row>

                <payment-methods :full-width="true" :can-add="false" :can-delete="false" :can-select="true"
                                 v-show="!showForm" v-model="selectedPaymentMethodId"></payment-methods>

                <b-row class="mt-3" v-if="!showForm && (paymentMethods && paymentMethods.length > 0)">
                    <b-col cols="12">
                        <b-button variant="outline-primary" block @click="openForm">
                            {{$t('tests.wizard.payment_step.use_another_payment_method')}}
                        </b-button>
                    </b-col>
                </b-row>
                <!--Form-->
                <div class="stripe_form" v-show="showForm || !paymentMethods || paymentMethods.length < 1">
                    <b-row class="mb-2">
                        <b-col cols="12">
                            <b-button variant="outline-primary" block @click="closeForm"
                                      v-if="(paymentMethods && paymentMethods.length > 0)">
                                {{$t('tests.wizard.payment_step.select_from_saved_payment_methods')}}
                            </b-button>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="7">
                            <b-form-group :label="$t('tests.wizard.payment_step.card_number')" label-for="card_number">
                                <div id="card_number_wrapper"></div>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col cols="5">
                            <b-form-group label-for="fullName">
                                <template v-slot:label>
                                    <span v-html="$t('tests.wizard.payment_step.full_name')"></span>
                                    <span class="tooltip-icon">
										<em class="icon-help-circle"
                                           v-b-popover.hover.top.html="{customClass: 'position-custom', content: '<img src=/img/app/card-holder.png>'}"></em>
									</span>
                                </template>
                                <b-form-input
                                        id="fullName"
                                        v-model="fullName"
                                        type="text"
                                        required
                                        :state="fullNameError ? false : null"
                                        :placeholder="$t('tests.wizard.payment_step.full_name_placeholder')"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="4">
                            <b-form-group label-for="expiry_date">
                                <template v-slot:label>
                                    <span v-html="$t('tests.wizard.payment_step.expiry_date')"></span>
                                    <span class="tooltip-icon">
										<em class="icon-help-circle"
                                           v-b-popover.hover.top.html="{customClass: 'position-custom', content: '<img src=/img/app/card-expiry.png>'}"></em>
									</span>
                                </template>
                                <div id="expiry_date_wrapper"></div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="3">
                            <b-form-group label-for="cvv">
                                <template v-slot:label>
                                    <span v-html="$t('tests.wizard.payment_step.cvv')"></span>
                                    <span class="tooltip-icon">
										<em class="icon-help-circle"
                                           v-b-popover.hover.top.html="{customClass: 'position-custom', content: '<img src=/img/app/card-cvv.png>'}"></em>
									</span>
                                </template>
                                <div id="cvv_wrapper"></div>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="8">
                            <b-form-group :label="$t('tests.wizard.payment_step.business_vat')"
                                          label-for="optionalCard">
                                <b-form-input
                                        id="optionalCard"
                                        type="text"
                                        placeholder="1234 1234 1234 1234"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12">
                            <b-form-checkbox v-model="saveCard">{{$t('tests.wizard.payment_step.save_card')}}
                            </b-form-checkbox>
                        </b-col>
                    </b-row>
                </div>

                <b-row class="stripe-row-info mt-3">
                    <b-col cols="12">
                        <span>{{ $t('tests.wizard.payment_step.secure_payments') }}</span>
                        <img class="stripe_logo" :src="'/img/app/stripe.svg'" alt="">
                    </b-col>
                </b-row>
            </b-col>

            <b-col cols="12" md="4" order="1" order-md="2">
                <div class="price-side">
                    <b-row class="my-2">
                        <b-col cols="12">
                            <b-input-group>
                                <b-form-input v-model="couponCode"
                                              :placeholder="$t('user.coupon_label')"></b-form-input>

                                <b-input-group-append :is-text="true" v-if="coupon">
                                    <em class="icon-check-url"></em>
                                </b-input-group-append>

                                <b-input-group-append :is-text="true" v-if="couponError">
                                    <em class="icon-alert"></em>
                                </b-input-group-append>

                                <b-input-group-append :is-text="true" v-if="isCouponBeingChecked">
                                    <b-spinner small></b-spinner>
                                </b-input-group-append>
                            </b-input-group>
                            <b-form-invalid-feedback v-if="couponError" :state="couponError" :force-show="true"
                                                     tag="span">
                                {{couponError}}
                            </b-form-invalid-feedback>
                        </b-col>
                    </b-row>
                    <div class="own_testers_price_badge" v-if="$parent.test.own_testers">
                        {{ $t('tests.wizard.payment_step.own_testers_price') }}
                        <span class="own_testers_price">
							<span class="own_testers_price_currency">$</span> {{$parent.ownTestersPrice | price}}
						</span>
                    </div>
                    <div class="testers_packages d-block" v-if="selectedPackage">
                        <div class="col-tester-12">
                            <div class="testers_package_item selected">
                                <em v-bind:class="{'icon-testers-1': (selectedPackage.testers == 10), 'icon-testers-2' : (selectedPackage.testers == 20), 'icon-testers-3' : (selectedPackage.testers == 30)}"></em>
                                <h4>{{ selectedPackage.title[$root.lang] }}</h4>
                                <strong class="testers_package_price"
                                   :class="{'text-decoration-line-through' : !_.isNull(price) && price !== selectedPackage.price}">
                                    <span class="testers_package_price_currency">{{$root.currencyLabel}}</span>
                                    {{ selectedPackage.price}}
                                </strong>
                                <strong class="testers_package_price"
                                   v-if="!_.isNull(price) && price !== selectedPackage.price">
                                    <span class="testers_package_price_currency">{{$root.currencyLabel}}</span>
                                    {{ price.toFixed(2) }}
                                </strong>
                                <div class="testers_package_button_wrapper">
                                    <b-button variant="link" @click="$parent.previousStep">{{
                                        $t('tests.wizard.payment_step.edit_package') }}
                                    </b-button>
                                </div>
                            </div>
                            <ul class="list-unstyled">
                                <li v-for="feature in JSON.parse(selectedPackage.features[$root.lang])">
                                    <em class="icon-double-check-list"></em>
                                    <span>{{feature.feature}}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </b-col>
        </b-row>
        <tests-wizard-buttons-block :next="purchase" :previous="$parent.previousStep"
                                    :isButtonDisabled="isButtonDisabled"
                                    :nextLabel="price === 0 ? $t('tests.wizard.payment_step.get_free') : $t('tests.wizard.payment_step.pay_now')"
        ></tests-wizard-buttons-block>
    </div>

</template>

<script>
    import {mapGetters} from 'vuex';
    import {errors} from "../../mixins/errors";
    import PaymentMethods from "../partials/payment-methods";
    import utilsApi from '../../api/utils';

    export default {
        name: 'tests-wizard-payment-step',
        components: {PaymentMethods},
        mixins: [errors],
        computed: {
            isButtonDisabled() {
                return (!this.showForm && this.paymentMethods && this.paymentMethods.length > 0 && !this.selectedPaymentMethodId) && (_.isNull(this.price) || this.price > 0);
            },
            selectedPackage() {
                return _.find(this.testersPackagesOptions, packageItem => packageItem.id === this.$parent.test.package_id);
            },
            ...mapGetters({
                testersPackagesOptions: 'options/testersPackagesOptions',
                paymentMethods: 'user/paymentMethods',
            })
        },
        data() {
            return {
                card: {
                    cardNumber: null,
                    cardExpiry: null,
                    cardCvc: null

                },
                stripe: null,
                hasCardErrors: false,
                fullName: null,
                fullNameError: false,
                showForm: false,
                selectedPaymentMethodId: null,
                saveCard: true,
                couponError: null,
                couponCode: null,
                coupon: null,
                isCouponBeingChecked: false,
                price: null
            }
        },

        mounted: function () {
            if (this.testersPackagesOptions.length < 1) {
                this.$store.dispatch('options/loadTestersPackagesOptions');
            }
            this.stripe = Stripe(this.$root.stripePublicKey, {
                locale: this.$root.lang
            });
            let elements = this.stripe.elements();
            this.card.cardNumber = elements.create('cardNumber', {
                classes: {
                    base: 'form-control',
                    invalid: 'is-invalid'
                },
                style: {
                    base: {
                        color: '#454545',
                        lineHeight: '46px',
                        fontWeight: 300,
                        fontSize: '15px',

                        '::placeholder': {
                            color: '#a5a5a5',
                        },
                    },
                },
                placeholder: this.$t('tests.wizard.payment_step.card_number_placeholder')
            });
            this.card.cardNumber.mount('#card_number_wrapper');

            this.card.cardExpiry = elements.create('cardExpiry', {
                classes: {
                    base: 'form-control',
                    invalid: 'is-invalid'
                },
                style: {
                    base: {
                        color: '#454545',
                        lineHeight: '46px',
                        fontWeight: 300,
                        fontSize: '15px',

                        '::placeholder': {
                            color: '#a5a5a5',
                        },
                    },
                },
                placeholder: this.$t('tests.wizard.payment_step.expiry_date_placeholder')
            });
            this.card.cardExpiry.mount('#expiry_date_wrapper');

            this.card.cardCvc = elements.create('cardCvc', {
                classes: {
                    base: 'form-control',
                    invalid: 'is-invalid'
                },
                style: {
                    base: {
                        color: '#454545',
                        lineHeight: '46px',
                        fontWeight: 300,
                        fontSize: '15px',

                        '::placeholder': {
                            color: '#a5a5a5',
                        },
                    },
                },
                placeholder: this.$t('tests.wizard.payment_step.cvv_placeholder')
            });
            this.card.cardCvc.mount('#cvv_wrapper');
            this.card.cardCvc._formSubmit();
            this.card.cardCvc.blur();
        },


        methods: {
            purchase: function () {
                this.fullNameError = false;

                //TODO: Fix validation!!!

                /*
                if (!this.fullName) {
                    this.fullNameError = true;
                    this.hasCardErrors = true;
                    Vue.set(this.errors, 'fullName', true);
                    return this.handleResponseErrors({status: 422, message: this.$t('validation.required', {attribute: this.$t('tests.wizard.payment_step.full_name')})});
                }
                */

                let intentId = null,
                    invoiceId = null;
                const packageItem = this.selectedPackage;
                if (packageItem) {
                    gtag('event', 'checkout_progress', {
                        "items": [
                            {
                                'id': packageItem.id,
                                'name': packageItem.title.en,
                                'list_name': 'Packages List',
                                'quantity': 1,
                                'price': packageItem.price
                            }
                        ],
                        "coupon": this.coupon ? this.couponCode : ""
                    });
                }
                return this.$store.dispatch('tests/createIntent', {test: this.$parent.test, coupon: this.coupon}).then(result => {
                    this.$store.commit('setIsLoading', true, {root: true});

                    if (result.error) {
                        this.$store.commit('setIsLoading', false, {root: true});
                        this.$forceUpdate();
                        return Promise.reject(result.error);
                    }
                    invoiceId = result.invoiceId;
                    if (!result.intent && this.price === 0) {
                        return Promise.resolve({});
                    }
                    intentId = result.intent.id;
                    return this.stripe.confirmCardPayment(result.intent.client_secret, {
                        setup_future_usage: this.saveCard ? 'off_session' : null,
                        payment_method: (this.showForm || !this.selectedPaymentMethodId) ? {
                            card: this.card.cardNumber,
                            billing_details: {
                                name: this.fullName,
                                email: this.$store.getters['auth/user'].email
                            },
                        } : this.selectedPaymentMethodId
                    });
                }).then(confirmation => {

                    this.$store.dispatch('tests/payment', {
                        test: this.$parent.test,
                        paymentIntentId: intentId,
                        invoiceId
                    });

                    if (confirmation.error) {
                        this.$store.commit('setIsLoading', false, {root: true});
                        this.hasCardErrors = true;
                        this.$forceUpdate();
                        return Promise.reject(confirmation.error);
                    }
                }).then(() => {
                    const packageItem = this.selectedPackage;
                    gtag('event', 'purchase', {
                        "transaction_id": intentId,
                        "value": !_.isNull(this.price)? this.price : packageItem.price,
                        "currency": process.env.MIX_STRIPE_CURRENCY,
                        "tax": 0,
                        "shipping": 0,
                        "items": [
                            {
                                'id': packageItem.id,
                                'name': packageItem.title.en,
                                'list_name': 'Packages List',
                                'quantity': 1,
                                'price': packageItem.price
                            }
                        ]
                    });
                    this.$parent.nextStep();
                }).catch(e => {
                    this.handleResponseErrors(e);
                });
            },
            openForm() {
                this.showForm = true;
            },
            closeForm() {
                this.showForm = false;
            },
            applyCoupon(coupon) {
                this.coupon = coupon;
                if (coupon.amount_off) {
                    return this.price = this.selectedPackage.price - (coupon.amount_off / 100);
                }
                if (coupon.percent_off) {
                    return this.price = this.selectedPackage.price - (this.selectedPackage.price * (coupon.percent_off / 100));
                }
            }
        },
        watch: {
            testersPackagesOptions: {
                handler() {
                    const packageItem = this.selectedPackage;
                    if (packageItem) {
                        gtag('event', 'begin_checkout', {
                            "items": [
                                {
                                    'id': packageItem.id,
                                    'name': packageItem.title.en,
                                    'list_name': 'Packages List',
                                    'quantity': 1,
                                    'price': packageItem.price
                                }
                            ],
                            "coupon": ""
                        });
                    }

                }
            },
            couponCode: {
                handler: _.debounce(function () {
                    if (this.isCouponBeingChecked) {
                        return;
                    }
                    this.coupon = null;
                    this.price = null;
                    this.couponError = null;
                    if (!this.couponCode) {
                        return;
                    }
                    this.isCouponBeingChecked = true;
                    utilsApi.validateCoupon(this.couponCode).then(coupon => {
                        this.applyCoupon(coupon);
                    }).catch(error => {
                        this.couponError = error.message;
                    }).finally(() => {
                        this.isCouponBeingChecked = false;
                    });
                }, 500)
            }
        },
    }
</script>

<style scoped>

</style>
